export default __webpack_public_path__ + "aa572ffe2b5ff6216a546d210fe8b7a1.ttf";